module.exports = __webpack_public_path__ + "img/houfnice_wagon_wheel.c9d5d840.gif";